// extracted by mini-css-extract-plugin
export default {"link-container":"shMgcY","linkContainer":"shMgcY","link-fade-in":"gLlYDs","linkFadeIn":"gLlYDs","icon":"MSY6Dj","ltr":"g0zR6L","rtl":"ZINM2A"};